var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "input-debounced",
            _vm._b(
              {
                staticClass: "w-100",
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              },
              "input-debounced",
              _vm.input,
              false
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseList",
        _vm._b(
          {
            ref: "list",
            staticClass: "overflow-auto",
            attrs: { url: _vm.url },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (slotProps) {
                    return [_vm._t("default", null, null, slotProps)]
                  },
                },
              ],
              null,
              true
            ),
          },
          "BaseList",
          _vm.list,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }